import React from "react";

// Style
import classStyles from "./index.module.css";

const ButtonLink = (props) => {
  const { class_name, children, style } = props;

  return (
    <>
      <div
        style={style}
        className={`${class_name} ${classStyles.ButtonLink}`}
        {...props}
      >
        {children}
      </div>
    </>
  );
};

export default ButtonLink;
